import React from "react";

// Add people to your account to give them access to manage your orders. 
const AccountHelptext = () => (
  <div className="helptext">
    <p>Please note that if you want to close your account, you have to cancel any subscription you may have active.</p>
  </div>
)

export default AccountHelptext;